import Modal from 'react-modal';
import { custom, customFullModal, getParameter, showDecimalMark } from '../../../classes/functions';
import { useState } from 'react';
import './index.css';

export default function ModalStatus({modalStatus, setModalStatus, newStatus, setNewState, states, changeStatus, listItems}){
    return (
      <Modal
        isOpen={modalStatus}
        onRequestClose={() => setModalStatus(false)}
        style={listItems?.length > 0 ? custom("75%", "auto") : custom("auto", "auto")}
        className="modal-status"
      >
        <div className="status-modal">
              <div className="status-modal__header">
                <h3 className="status-modal___title">Novo status</h3>
                <select value={newStatus} onChange={ (e) => setNewState(e.target.value) } className="status-modal___select" >
                  <option value="">Selecione</option>
                  {states.map((status, index) => {
                    return (
                      <option value={status.chave || status.value} key={index}>{status.descricao || status.label}</option>
                    )
                  })}
                </select>
              </div>
              {listItems?.length > 0 && <div className="container">
                <h2>Os seguintes itens usaram saldo de outras características. Ao aprovar você estará confirmando a movimentação de saldo.</h2>
                <br />
                <table>
                  <thead>
                    <tr>
                      <th scope="col" className='collumOption'>#</th>
                      <th scope="col">Produto</th>
                      <th scope="col">Main Code</th>
                      <th scope="col">Quantidade</th>
                      <th scope="col">Qtde. Característica</th>
                      <th scope="col">Qtde. Compartilhada</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listItems?.map((item, index)=>{
                      return(
                        <tr>
                          <td data-label="">{index+1}</td>
                          <td data-label="">{item.product_code} - {item.product_name}</td>
                          <td data-label="">{item.main_code}</td>
                          <td data-label="">{showDecimalMark(item.amount)}</td>
                          <td data-label="">{showDecimalMark(item.feature_balance)}</td>
                          <td data-label="">{showDecimalMark(item.feature_shared_balance)}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>}
              <div className="status-modal__buttons">
                <button type="button" className="status-modal___button" onClick={changeStatus}>Confirmar</button>
                <button type="button" className="status-modal___button" id="button-close" onClick={() => setModalStatus(false)}>Fechar</button>
              </div>
            </div>
      </Modal>
    )
}